/* Escalado de cantidades con su precio + «otra cantidad» (silicona y llaveros).
 *
 * Tarjetas como en los cordones (clases cnt__cants / cnt__cant de cinta-editor.css). La última tarjeta es «Otra cantidad»:
 * el cliente escribe un número y se cobra el PRECIO POR UNIDAD DEL ESCALÓN DE ABAJO × sus unidades
 * (con escalones de 50 y 100, 80 uds = precio unitario de 50 × 80). Equivale al escalón de abajo + las unidades que sobran
 * a ese mismo precio por unidad. Si el escalón de arriba sale más barato que su cantidad, se lo sugiere.
 *
 *   Escalado.libre(tiers, n)  -> { base, sobran, unit, extra, total, uds } | null   (tiers: [{cant: Number, precio: €}] ascendente)
 *   Escalado.montar(cont, { eur, min, max, titulo, waMsg, onCambio })  -> { pintar(tiers, sel, libre) }
 *     onCambio({ cant: '100' })  o  onCambio({ libre: 80 | null })
 */
(function () {
  'use strict';

  function libre(tiers, n) {
    var base = null;
    tiers.forEach(function (t) { if (t.cant <= n) base = t; });
    if (!base) return null;
    var u = base.precio / base.cant, sobran = n - base.cant, extra = Math.round(sobran * u);
    return { base: base.cant, sobran: sobran, unit: u, extra: extra, total: base.precio + extra, uds: n };
  }

  function montar(cont, o) {
    cont.innerHTML = '<div class="esc-lista" data-esc-grid></div>' +
      '<div class="esc-libre" data-esc-libre hidden><label>Escribe cuántas quieres<span class="esc-libre__f"><input type="text" inputmode="numeric" autocomplete="off" maxlength="6" data-esc-input aria-label="Otra cantidad"> uds</span></label>' +
      '<p class="esc-libre__m" data-esc-msg aria-live="polite"></p></div>';
    var grid = cont.querySelector('[data-esc-grid]'), caja = cont.querySelector('[data-esc-libre]'),
      inp = cont.querySelector('[data-esc-input]'), msg = cont.querySelector('[data-esc-msg]');
    var tiersAct = [], abierta = false, estado = { sel: null, libre: null };

    function mensaje() {
      var txt = inp.value.replace(/\D/g, ''), n = parseInt(txt, 10);
      msg.innerHTML = '';
      if (!txt) { msg.textContent = 'Desde ' + o.min + ' uds. Entre dos escalones se cobra el precio por unidad del escalón de abajo.'; return; }
      if (n < o.min || n > o.max) {
        var a = document.createElement('a');
        a.href = 'https://wa.me/34934358257?text=' + encodeURIComponent(o.waMsg(txt)); a.target = '_blank'; a.rel = 'noopener'; a.textContent = 'escríbenos por WhatsApp';
        msg.appendChild(document.createTextNode((n < o.min ? 'El mínimo es de ' + o.min + ' uds; para menos, ' : 'Para más de ' + o.max + ' uds, ')));
        msg.appendChild(a); msg.appendChild(document.createTextNode(' y te hacemos presupuesto.'));
        return;
      }
      var l = libre(tiersAct, n); if (!l) return;
      msg.appendChild(document.createTextNode(n + ' uds × ' + o.eur(l.unit) + ' (el precio por unidad del escalón de ' + l.base + ') = ' + o.eur(l.total) + '. '));
      var sig = tiersAct.filter(function (t) { return t.cant > n; })[0];
      if (sig && sig.precio <= l.total) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'esc-libre__bt'; b.textContent = 'Elegir el de ' + sig.cant;
        msg.appendChild(document.createTextNode('El de ' + sig.cant + ' uds sale a ' + o.eur(sig.precio) + ', menos que esto. '));
        msg.appendChild(b);
        b.addEventListener('click', function () { inp.value = ''; abierta = false; o.onCambio({ cant: String(sig.cant) }); });
      }
    }

    grid.addEventListener('click', function (e) {
      var c = e.target.closest('[data-cant]');
      if (c) { inp.value = ''; abierta = false; o.onCambio({ cant: c.getAttribute('data-cant') }); return; }
      if (e.target.closest('[data-esc-otra]')) { abierta = true; caja.hidden = false; mensaje(); inp.focus(); var n = parseInt(inp.value, 10); if (n >= o.min && n <= o.max) o.onCambio({ libre: n }); else pintarGrid(); }
    });
    grid.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-cant],[data-esc-otra]')) { e.preventDefault(); e.target.click(); } });
    inp.addEventListener('input', function () {
      inp.value = inp.value.replace(/\D/g, '').slice(0, 6);
      var n = parseInt(inp.value, 10);
      mensaje();
      o.onCambio({ libre: (n >= o.min && n <= o.max) ? n : null });
    });

    function pintarGrid() {
      var tiers = tiersAct, u0 = tiers.length ? tiers[0].precio / tiers[0].cant : 0;
      grid.innerHTML = tiers.map(function (t, i) {
        var u = t.precio / t.cant, ah = i ? Math.round((1 - u / u0) * 100) : 0;
        return '<div class="esc-fila' + (!estado.libre && String(t.cant) === String(estado.sel) ? ' on' : '') + '" data-cant="' + t.cant + '" role="button" tabindex="0">' +
          '<span class="n">' + t.cant + ' uds</span><span class="u">' + o.eur(u) + '/ud' + (ah > 0 ? ' <em>−' + ah + ' %</em>' : '') + '</span><span class="p">' + o.eur(t.precio) + '</span></div>';
      }).join('') + (o.sinLibre ? '' : '<div class="esc-fila esc-fila--otra' + (estado.libre || abierta ? ' on' : '') + '" data-esc-otra role="button" tabindex="0"><span class="n">Otra cantidad</span>' +
        '<span class="u">' + (estado.libre ? estado.libre + ' uds a medida' : 'tú eliges cuántas') + '</span><span class="p">' + (estado.libre ? '' : '…') + '</span></div>');
      caja.hidden = o.sinLibre || !(estado.libre || abierta);
    }

    return {
      pintar: function (tiers, sel, libreN) {
        tiersAct = tiers; estado = { sel: sel, libre: libreN };
        if (libreN && document.activeElement !== inp) inp.value = String(libreN);
        pintarGrid();
        if (!caja.hidden) mensaje();
      }
    };
  }

  window.Escalado = { libre: libre, montar: montar };
})();
